import React, { useEffect, useRef, useState } from "react";
import { Checkbox, Form, Input, InputNumber, Modal, Select, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { save } from "../../../../features/save/saveSlice";
import {
  fetchLeaveType,
  fetchStaffGrade,
} from "../../../../features/dropdown/dropdownSlice";

const { TextArea } = Input;

const AddLeaveDayModal = ({ open, handleCancel, handleFetchData, prodd }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { leaveType, staffGradeData, loading } = useSelector(
    (state) => state.dropdown
  );
  const { saving } = useSelector((state) => state.save);

  const [formData, setFormData] = useState(prodd);

 

  const onChangeOther = (value, fieldName) => {
    setFormData((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };

  async function handleSelectChange(value, formName) {
    await setFormData((prevData) => ({
      ...prevData,
      [formName]: value,
    }));
  }

  const onFinish = async (data) => {
    if (!formData?.ltId) {
      toast.error("Please select leave type");
      return;
    }
    if (!formData?.sgId) {
      toast.error("Please select staff grade");
      return;
    }
    if (!formData?.ldDays) {
      toast.error("Please provide leave days");
      return;
    }

    const res = await dispatch(
      save({
        ltId: prodd?.ltId ? prodd?.ltId : null,
        ltId: formData?.ltId,
        sgId: formData?.sgId,
        ldDays: formData?.ldDays,
        url: "hr/saveLeaveDay.action",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleFetchData();
      await setFormData({});
      await handleCancel();
      await form.resetFields();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  async function fetchLeaveTypeData(page, size) {
    dispatch(fetchLeaveType());
  }
  async function fetchStaffGradeData(page, size) {
    dispatch(fetchStaffGrade());
  }

  useEffect(() => {
    setFormData(prodd);
  }, [prodd]);

 
  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title={
          prodd
            ? `Edit leave  ${prodd?.ltLvtypename}`
            : "Add leave days details"
        }
        open={open}
        onOk={onFinish}
        onCancel={handleCancel}
        width={850}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className=" "
          style={{
            maxWidth: "100%",
          }}
          form={form}
        >
          <Form.Item
            className=""
            label={<span>Leave Type</span>}
            rules={[
              {
                required: true,
                message: "Please select Leave Type",
              },
            ]}
          >
            <Select
              name="ltLvtype"
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                leaveType?.length > 0 &&
                leaveType?.map((item) => ({
                  value: item?.ltId,
                  label: item?.ltLvtypename,
                }))
              }
              onChange={(value) => {
                handleSelectChange(value, "ltId");
              }}
              value={formData?.ltId}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
              onDropdownVisibleChange={() => {
                fetchLeaveTypeData();
              }}
              dropdownRender={(menu) => (
                <>
                  {loading && (
                    <div
                      style={{
                        padding: "8px",
                        textAlign: "center",
                      }}
                    >
                      <Spin className="sms-spin" />
                    </div>
                  )}
                  {menu}
                </>
              )}
            />
          </Form.Item>

          <Form.Item
            className=""
            label={<span>Staff Grade</span>}
            rules={[
              {
                required: true,
                message: "Please select staff grade",
              },
            ]}
          >
            <Select
              name="sgId"
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                staffGradeData?.length > 0 &&
                staffGradeData?.map((item) => ({
                  value: item?.sgId,
                  label: item?.sgGradename,
                }))
              }
              onChange={(value) => {
                handleSelectChange(value, "sgId");
              }}
              value={formData?.sgId}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
              onDropdownVisibleChange={() => {
                fetchStaffGradeData();
              }}
              dropdownRender={(menu) => (
                <>
                  {loading && (
                    <div
                      style={{
                        padding: "8px",
                        textAlign: "center",
                      }}
                    >
                      <Spin className="sms-spin" />
                    </div>
                  )}
                  {menu}
                </>
              )}
            />
          </Form.Item>

          <Form.Item
            label="Days"
            rules={[
              {
                required: true,
                message: "Enter number of Days",
              },
            ]}
          >
            <InputNumber
              name="ldDays"
              value={formData?.ldDays}
              min={0}
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
              onChange={(value) => onChangeOther(value, "ldDays")}
              placeholder="Enter leave days"
              className="input flex"
            />
          </Form.Item>

          <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center gap-x-2">
              <div className="w-[200px]">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancel}
                  className="cstm-btn !bg-white !text-lightBlack !border !border-lightBlack"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[200px]">
                <button
                  key="submit"
                  type="submit"
                  className="cstm-btn"
                  disabled={saving}
                >
                  {saving ? <Spin /> : "Create"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default AddLeaveDayModal;
